
export default {
    name: 'info-operation',
    components: {},
    props: {
        info_operation: Object
    },
    data () {
        return {

        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {

    }
}


